import React from "react";
import { CheckOutlined } from "@ant-design/icons";

const AudienceStepIndicator = ({ number, label, state, lineActive, isLast }) => {
  const isDone = state === "done";
  const isCurrent = state === "current";
  
  return (
    <div className="tw-flex tw-items-start">
      <div className="tw-flex tw-flex-col tw-items-center">
        <div
          className={`tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-text-xs tw-font-semibold tw-transition-all tw-duration-300 ${
            isDone
              ? "tw-bg-[#5D44FF] tw-border-0 tw-text-white"
              : isCurrent
                ? "tw-bg-white tw-border-[2px] tw-border-solid tw-border-[#5D44FF] tw-text-[#5D44FF]"
                : "tw-bg-[#F8FAFC] tw-border tw-border-solid tw-border-[#E2E8F0] tw-text-[#94A3B8]"
          }`}
        >
          {isDone ? <CheckOutlined className="tw-text-[10px] tw-stroke-[2]" /> : number}
        </div>
        <span
          className={`tw-mt-1.5 tw-whitespace-nowrap tw-text-[11px] tw-transition-all tw-font-poppins ${
            isCurrent
              ? "tw-font-bold tw-text-[#5D44FF]"
              : isDone
                ? "tw-font-semibold tw-text-[#0F172A]"
                : "tw-font-normal tw-text-[#94A3B8]"
          }`}
        >
          {label}
        </span>
      </div>
      {!isLast ? (
        <div
          className={`tw-mx-3 tw-mt-4 tw-h-[2px] tw-w-[120px] tw-rounded-full tw-transition-all tw-duration-300 ${
            lineActive ? "tw-bg-[#5D44FF]" : "tw-bg-[#E2E8F0]"
          }`}
        />
      ) : null}
    </div>
  );
};

export default AudienceStepIndicator;
